module.exports = __webpack_public_path__ + "static/img/continueModalImg.6745d8bf.svg";